import React from "react";
import PageContainer from "../../../themes/components/PageContainer";
import PageHeading from "../../../themes/components/PageHeading";
import BackButton from "../../../themes/components/BackButton";
import NotFound from "../../../common/pages/NotFound";
import { AccessPermissionContext } from "../../../providers/AccessPermissionsProvider";
import SegmentationBlocksHistoryContent from "../components/segmentation-blocks/SegmentationBlocksHistoryContent";
import FeatureFlags from "../../../common/feature-flagging/FeatureFlags";
import { useEnabledFeatureFlag } from "../../../common/feature-flagging/FeatureFlagProvider";

const SegmentationBlocksHistoryPage: React.FC = () => {
  const { hasPermissions } = React.useContext(AccessPermissionContext);
  const isSegmentationBlocksFeatureEnabled = useEnabledFeatureFlag(
    FeatureFlags.EMPLOYER_ODP_SEGMENTATION_BLOCKS
  );

  if (!hasPermissions) {
    return <NotFound />;
  }

  // Show NotFound if feature flag is disabled
  if (!isSegmentationBlocksFeatureEnabled) {
    return <NotFound />;
  }

  return (
    <PageContainer>
      <div className="flex items-center gap-4 mb-6">
        <BackButton to="/financial-benefits">
          Back to Financial Benefits
        </BackButton>
      </div>
      <PageHeading title="Segmentation Blocks History" />
      <div className="mt-6">
        <SegmentationBlocksHistoryContent />
      </div>
    </PageContainer>
  );
};

export default SegmentationBlocksHistoryPage;
